<template>
	<div class="w-full">
        <div id="map" style="height: calc(100vh - 150px)"></div>
    </div>
</template>

<script>

	import * as Config from '@/config'
	import { mapState, mapGetters } from 'vuex';
    import { EventBus } from '@/utils/events';
    import * as mapboxgl from 'mapbox-gl'


	export default {
		name: 'AdminCoverageMap',
		data () {
			return {
                map: null,
			}
		},
		mounted() {
            this.getUsers();
            this.initializeMap();
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
			]),
	
            initializeMap() {
                var _this = this;
                this.map = new mapboxgl.Map({
                    container: 'map',
                    style: 'https://tiles.livestormchasing.com/styles/dark-matter/style.json',
                    center: [
                        -97.380979,
                        40
                    ],
                    zoom: 3.5,
                });
                this.map.on('style.load', function() {
                    _this.map.dragRotate.disable();
                    _this.map.touchZoomRotate.disableRotation();
                    _this.getUsers();
                });
            },

            getUsers() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/users?geojson=true", this.getAuthorizationHeader()).then((response) => {
                    
                    _this.map.addSource('users', {
                        "type": "geojson",
                        "data": response.data
                    })

                    _this.map.addLayer({
                        "id": "users",
                        "type": "circle",
                        "source": "users",
                        "paint": {
                            "circle-radius": 6,
                            "circle-color": {
                                property: 'videoActivity',
                                stops: [[0, '#c0392b'], [20, '#27ae60']]
                            }
                        },
                    });
                });
            },

		},
       
	}
</script>